import { Navigate, NavLink, Outlet, Link } from "react-router-dom";
import { reloadIfSame } from "@/lib/reloadSame";
import { LayoutDashboard, Package, Receipt, LogOut, Store, MessageSquareText, Puzzle, ShieldCheck, ListOrdered, FileText } from "lucide-react";
import { SeatIcon } from "@/components/shop/SeatIcon";
import { useAuth } from "@/lib/auth";

const items = [
  ["/admin", "Statistika", LayoutDashboard, "admin-nav-dashboard", true],
  ["/admin/products", "Sėdynės ir likučiai", Package, "admin-nav-products"],
  ["/admin/catalog-order", "Katalogo tvarka", ListOrdered, "admin-nav-catalog-order"],
  ["/admin/orders", "Užsakymai", Receipt, "admin-nav-orders"],
  ["/admin/inquiries", "Užklausos", MessageSquareText, "admin-nav-inquiries"],
  ["/admin/options", "Priedai", Puzzle, "admin-nav-options"],
  ["/admin/invoices", "Sąskaitos", FileText, "admin-nav-invoices"],
  ["/admin/privacy", "Duomenų apsauga", ShieldCheck, "admin-nav-privacy"],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#1F2230]" />;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#1F2230] md:flex">
      <aside className="md:w-60 md:min-h-screen border-b md:border-b-0 md:border-r border-[#3B4157] bg-[#252937] p-4 flex md:flex-col gap-2">
        <div className="hidden md:flex items-center gap-2 mb-8 px-2 pt-2">
          <span className="grid place-items-center w-8 h-8 bg-orange-500 text-[#1F2230]"><SeatIcon className="w-4 h-4" /></span>
          <span className="font-display font-black uppercase text-lg">Admin</span>
        </div>
        <div className="order-last md:order-none ml-auto md:ml-0 flex md:flex-col gap-2 md:pb-4 md:mb-2 md:border-b border-[#3B4157]">
          <Link to="/" data-testid="admin-nav-shop" className="flex items-center gap-3 px-3 h-10 text-sm text-slate-400 hover:text-white"><Store className="w-4 h-4" /><span className="hidden sm:inline">Parduotuvė</span></Link>
          <button data-testid="admin-logout-btn" onClick={logout} className="flex items-center gap-3 px-3 h-10 text-sm text-slate-400 hover:text-red-400"><LogOut className="w-4 h-4" /><span className="hidden sm:inline">Atsijungti</span></button>
        </div>
        {items.map(([to, label, Icon, tid, end]) => (
          <NavLink key={to} to={to} end={end} data-testid={tid} onClick={reloadIfSame(to)}
            className={({ isActive }) => `flex items-center gap-3 px-3 h-10 text-sm transition-colors ${isActive ? "bg-orange-500/10 text-orange-500 border-l-2 border-orange-500" : "text-slate-400 hover:text-white"}`}>
            <Icon className="w-4 h-4" /><span className="hidden sm:inline">{label}</span>
          </NavLink>
        ))}
      </aside>
      <main className="flex-1 p-4 sm:p-8 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
